/* SMITHS CUSTOM: Region & currency module v1 - 2026-09-07
   ------------------------------------------------------------------
   WHY THIS EXISTS
   Shopify only lets a store CHECK OUT in more than one currency with
   Shopify Payments, which is not available in Kuwait. So this module does
   the honest version: every price on the storefront is re-expressed in the
   shopper's currency as an estimate, the pill says so, and checkout still
   settles in KWD. Nine currencies: KWD SAR AED QAR BHD OMR USD EUR GBP.

   WHAT IT DOES
   1. Detects the shopper's region (saved choice > Shopify market country >
      browser timezone) and picks the matching currency.
   2. For GCC / EU visitors still sitting in the default Kuwait market, it
      silently submits Shopify's own localization form ONCE so the market
      country (shipping zone, checkout country pre-fill) matches them.
      Shopify Plus does this natively; this store is not on Plus.
   3. Rewrites every "1,234.000 KD" / "KWD" text node on the page into the
      chosen currency and keeps doing so as the theme re-renders prices
      (variant change, cart drawer, quick view). KWD selected = originals.
   4. Adds a one-line note above every checkout button saying what the card
      is actually charged in KWD when a foreign currency is displayed.
   5. Exposes window.SmithsCurrency for other modules (the BNPL widget).

   RATES: base KWD, fetched from open.er-api.com (free, CORS, daily), cached
   12 h in localStorage, with a hard-coded fallback table from the section
   so the page never waits on the network.

   MONEY TRAP: the shop money format is {{amount}}0 KD - two real decimals
   plus a literal zero. 188.000 KD is 188.00 KD. /cart.js total_price is in
   the same 1/100 minor units (16600 == 166.000 KD).
   Defensive throughout: any failure leaves the page exactly as Shopify
   rendered it. */
(function () {
  'use strict';
  if (window.SmithsCurrency) return;

  var CFG = window.__smithsCurrency || {};
  var STORE = 'KWD';
  var LIST = CFG.currencies || ['KWD', 'SAR', 'AED', 'QAR', 'BHD', 'OMR', 'USD', 'EUR', 'GBP'];
  var FALLBACK = CFG.rates || {};
  var AVAILABLE = CFG.availableCountries || [];
  var CURRENT_COUNTRY = CFG.country || (window.Shopify && window.Shopify.country) || 'KW';
  var IS_AR = (document.documentElement.lang || '').toLowerCase().indexOf('ar') === 0;
  var LS_CUR = 'smiths_cur';
  var LS_FX = 'smiths_fx_v1';
  var SS_GEO = 'smiths_geo_done';
  var TTL = 12 * 60 * 60 * 1000;

  var DEC = { KWD: 3, BHD: 3, OMR: 3 };
  var NAMES = {
    KWD: ['Kuwaiti dinar', 'دينار كويتي', 'KW'],
    SAR: ['Saudi riyal', 'ريال سعودي', 'SA'],
    AED: ['UAE dirham', 'درهم إماراتي', 'AE'],
    QAR: ['Qatari riyal', 'ريال قطري', 'QA'],
    BHD: ['Bahraini dinar', 'دينار بحريني', 'BH'],
    OMR: ['Omani rial', 'ريال عماني', 'OM'],
    USD: ['US dollar', 'دولار أمريكي', 'US'],
    EUR: ['Euro', 'يورو', 'EU'],
    GBP: ['British pound', 'جنيه إسترليني', 'GB']
  };
  var COUNTRY_CUR = { KW: 'KWD', SA: 'SAR', AE: 'AED', QA: 'QAR', BH: 'BHD', OM: 'OMR', GB: 'GBP', US: 'USD' };
  var EU = ['AT', 'BE', 'CZ', 'DE', 'DK', 'ES', 'FI', 'FR', 'IE', 'IT', 'NL', 'PL', 'PT', 'SE', 'BG', 'HR', 'CY', 'EE', 'GR', 'HU', 'LU', 'LV', 'LT', 'MT', 'RO', 'SI', 'SK'];
  var TZ = {
    'Asia/Kuwait': 'KW', 'Asia/Riyadh': 'SA', 'Asia/Dubai': 'AE', 'Asia/Qatar': 'QA', 'Asia/Bahrain': 'BH', 'Asia/Muscat': 'OM',
    'Europe/London': 'GB', 'Europe/Vienna': 'AT', 'Europe/Brussels': 'BE', 'Europe/Prague': 'CZ', 'Europe/Berlin': 'DE',
    'Europe/Copenhagen': 'DK', 'Europe/Madrid': 'ES', 'Europe/Helsinki': 'FI', 'Europe/Paris': 'FR', 'Europe/Dublin': 'IE',
    'Europe/Rome': 'IT', 'Europe/Amsterdam': 'NL', 'Europe/Warsaw': 'PL', 'Europe/Lisbon': 'PT', 'Europe/Stockholm': 'SE',
    'Europe/Sofia': 'BG', 'Europe/Zagreb': 'HR', 'Asia/Nicosia': 'CY', 'Europe/Tallinn': 'EE', 'Europe/Athens': 'GR',
    'Europe/Budapest': 'HU', 'Europe/Luxembourg': 'LU', 'Europe/Riga': 'LV', 'Europe/Vilnius': 'LT', 'Europe/Malta': 'MT',
    'Europe/Bucharest': 'RO', 'Europe/Ljubljana': 'SI', 'Europe/Bratislava': 'SK'
  };

  function ls(k, v) {
    try {
      if (v === undefined) return window.localStorage.getItem(k);
      if (v === null) window.localStorage.removeItem(k); else window.localStorage.setItem(k, v);
    } catch (e) { return null; }
  }
  function ss(k, v) {
    try {
      if (v === undefined) return window.sessionStorage.getItem(k);
      window.sessionStorage.setItem(k, v);
    } catch (e) { return null; }
  }

  /* ---------- region detection ---------- */
  function tzCountry() {
    try {
      var tz = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
      if (TZ[tz]) return TZ[tz];
      if (tz.indexOf('America/') === 0) return 'US';
    } catch (e) {}
    return null;
  }
  function currencyForCountry(cc) {
    if (!cc) return null;
    if (COUNTRY_CUR[cc]) return COUNTRY_CUR[cc];
    if (EU.indexOf(cc) > -1) return 'EUR';
    return null;
  }
  function detect() {
    var saved = ls(LS_CUR);
    if (saved && LIST.indexOf(saved) > -1) return saved;
    var c = currencyForCountry(CURRENT_COUNTRY);
    if (c && CURRENT_COUNTRY !== 'KW' && LIST.indexOf(c) > -1) return c;
    var tc = currencyForCountry(tzCountry());
    if (tc && LIST.indexOf(tc) > -1) return tc;
    return STORE;
  }

  /* ---------- rates ---------- */
  var rates = null; // { code: rate } with KWD base, KWD = 1
  function loadRates() {
    var cached = null;
    try { cached = JSON.parse(ls(LS_FX) || 'null'); } catch (e) {}
    if (cached && cached.rates && (Date.now() - cached.ts) < TTL) { rates = cached.rates; return; }
    rates = FALLBACK;
    if (!(window.fetch)) return;
    fetch('https://open.er-api.com/v6/latest/KWD', { mode: 'cors' })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        if (!j || j.result !== 'success' || !j.rates) return;
        var out = { KWD: 1 };
        var ok = true;
        LIST.forEach(function (c) { if (typeof j.rates[c] === 'number') out[c] = j.rates[c]; else if (c !== 'KWD') ok = false; });
        if (!ok) return;
        rates = out;
        ls(LS_FX, JSON.stringify({ ts: Date.now(), rates: out }));
        applyAll();
        cartNote();
        emit();
      })
      .catch(function () {});
  }

  /* ---------- state ---------- */
  var active = detect();
  function rate(code) {
    code = code || active;
    if (code === STORE) return 1;
    var r = (rates && rates[code]) || FALLBACK[code];
    return (typeof r === 'number' && r > 0) ? r : null;
  }
  function decimals(code) { return DEC[code || active] !== undefined ? DEC[code || active] : 2; }
  function fmtNumber(n, code) {
    var d = decimals(code);
    try { return new Intl.NumberFormat('en', { minimumFractionDigits: d, maximumFractionDigits: d }).format(n); }
    catch (e) { return n.toFixed(d); }
  }
  /* kwd: a KWD amount as a float (188.00). Returns "2,239.78 AED" style string. */
  function format(kwd, code) {
    code = code || active;
    if (code === STORE) return fmtNumber(kwd, 'USD') + '0 KD'; /* shop format: 2 decimals + literal 0 */
    var r = rate(code);
    if (!r) return fmtNumber(kwd, 'KWD') + ' KD';
    return fmtNumber(kwd * r, code) + ' ' + code;
  }
  function convert(kwd, code) {
    var r = rate(code || active);
    return r ? kwd * r : kwd;
  }

  /* ---------- DOM rewriting ---------- */
  var RE = /(\d{1,3}(?:,\d{3})*(?:\.\d+)?|\d+(?:\.\d+)?)\s?(KWD|KD)(?![A-Za-z])/g;
  var SKIP = { SCRIPT: 1, STYLE: 1, TEXTAREA: 1, INPUT: 1, NOSCRIPT: 1, CODE: 1 };
  var tracked = [];
  var applying = false;

  function skippable(el) {
    while (el && el !== document.body) {
      if (SKIP[el.nodeName]) return true;
      if (el.hasAttribute && (el.hasAttribute('data-smiths-fx-skip') || el.hasAttribute('data-smiths-bnpl'))) return true;
      if (el.classList && (el.classList.contains('smiths-cur') || el.classList.contains('smiths-bnpl'))) return true;
      el = el.parentNode;
    }
    return false;
  }
  function rewrite(text, code) {
    return text.replace(RE, function (m, num) {
      var v = parseFloat(num.replace(/,/g, ''));
      if (isNaN(v)) return m;
      return format(v, code);
    });
  }
  function scan(root) {
    if (!root || !root.nodeType) return;
    var walker;
    try { walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null, false); } catch (e) { return; }
    var n;
    while ((n = walker.nextNode())) {
      var t = n.nodeValue;
      if (!t || t.indexOf('K') === -1) continue;
      RE.lastIndex = 0;
      if (!RE.test(t)) {
        /* a node we rewrote earlier whose text no longer carries KD: leave it */
        continue;
      }
      if (skippable(n.parentNode)) continue;
      if (n.__smithsOut !== undefined && n.nodeValue === n.__smithsOut) continue; /* already ours */
      n.__smithsOrig = t; /* theme re-rendered a fresh KD string: adopt it */
      if (tracked.indexOf(n) === -1) tracked.push(n);
    }
  }
  function applyAll() {
    applying = true;
    try {
      for (var i = tracked.length - 1; i >= 0; i--) {
        var n = tracked[i];
        if (!n.parentNode) { tracked.splice(i, 1); continue; }
        var out = active === STORE ? n.__smithsOrig : rewrite(n.__smithsOrig, active);
        if (n.nodeValue !== out) n.nodeValue = out;
        n.__smithsOut = out;
      }
    } finally { applying = false; }
  }
  var pending = null;
  function schedule(root) {
    if (applying) return;
    clearTimeout(pending);
    pending = setTimeout(function () { scan(root || document.body); applyAll(); cartNote(); }, 60);
  }

  /* ---------- cart note: what the card is actually charged ---------- */
  var cartCache = { ts: 0, total: null };
  function paintNotes(totalMinor) {
    var btns = document.querySelectorAll('#checkout-submit, button[name="checkout"]');
    applying = true;
    try {
      Array.prototype.forEach.call(btns, function (btn) {
        var host = btn.parentNode;
        if (!host) return;
        var note = null;
        for (var i = 0; i < host.children.length; i++) { if (host.children[i].className === 'smiths-cur__cartnote') { note = host.children[i]; break; } }
        if (active === STORE) { if (note) note.parentNode.removeChild(note); return; }
        if (btn.offsetParent === null) return;
        if (!note) {
          note = document.createElement('p');
          note.className = 'smiths-cur__cartnote';
          note.setAttribute('data-smiths-fx-skip', '');
          if (IS_AR) note.setAttribute('dir', 'rtl');
          host.insertBefore(note, btn);
        }
        var kd = format(totalMinor / 100, STORE);
        var txt = IS_AR
          ? ('يُخصم من بطاقتك ' + kd + ' عند الدفع — والمبلغ المعروض بعملتك تقديري.')
          : ('Your card is charged ' + kd + ' at checkout — the ' + active + ' amount is an estimate.');
        if (note.textContent !== txt) note.textContent = txt;
      });
    } finally { applying = false; }
  }
  function cartNote() {
    if (!document.querySelector('#checkout-submit, button[name="checkout"]')) return;
    if (active === STORE) { paintNotes(0); return; }
    if (cartCache.total !== null && (Date.now() - cartCache.ts) < 3000) { paintNotes(cartCache.total); return; }
    if (!window.fetch) return;
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
      if (!c || typeof c.total_price !== 'number') return;
      cartCache = { ts: Date.now(), total: c.total_price }; /* minor units, 1/100 on this store */
      paintNotes(c.total_price);
    }).catch(function () {});
  }

  /* ---------- localization (market country) switch ---------- */
  function countryAvailable(cc) { return AVAILABLE.indexOf(cc) > -1; }
  function switchCountry(cc) {
    var form = document.getElementById('smiths-localization-form');
    if (!form || !cc || cc === CURRENT_COUNTRY || !countryAvailable(cc)) return false;
    var input = form.querySelector('input[name="country_code"]');
    var ret = form.querySelector('input[name="return_to"]');
    if (!input) return false;
    input.value = cc;
    if (ret) ret.value = window.location.pathname + window.location.search;
    ss(SS_GEO, '1');
    form.submit();
    return true;
  }
  function autoGeo() {
    if (ss(SS_GEO)) return;
    ss(SS_GEO, '1');
    if (ls(LS_CUR)) return;               /* the shopper already chose - respect it */
    if (CURRENT_COUNTRY !== 'KW') return; /* already localized */
    var cc = tzCountry();
    if (!cc || cc === 'KW') return;
    if (!countryAvailable(cc)) return;    /* e.g. US / GB: no market -> display-only currency */
    switchCountry(cc);
  }

  /* ---------- public API ---------- */
  function emit() {
    try { document.dispatchEvent(new CustomEvent('smiths:currency', { detail: { code: active, rate: rate(active), decimals: decimals(active) } })); } catch (e) {}
  }
  function set(code, opts) {
    opts = opts || {};
    if (LIST.indexOf(code) === -1) return;
    active = code;
    ls(LS_CUR, code);
    applyAll();
    cartNote();
    renderPill();
    emit();
    if (!opts.silent) {
      var cc = NAMES[code] && NAMES[code][2];
      if (cc && cc !== 'EU' && cc !== CURRENT_COUNTRY && countryAvailable(cc)) switchCountry(cc);
    }
  }

  /* ---------- pill UI ---------- */
  var pill = null;
  function renderPill() {
    if (!pill) return;
    var code = pill.querySelector('[data-smiths-cur-code]');
    if (code) code.textContent = active;
    Array.prototype.forEach.call(pill.querySelectorAll('[data-smiths-cur-opt]'), function (b) {
      var on = b.getAttribute('data-smiths-cur-opt') === active;
      b.setAttribute('aria-checked', on ? 'true' : 'false');
      b.classList.toggle('is-active', on);
    });
    var note = pill.querySelector('[data-smiths-cur-note]');
    if (note) note.hidden = (active === STORE);
  }
  function mountPill() {
    pill = document.querySelector('[data-smiths-cur]');
    if (!pill) return;
    var list = pill.querySelector('[data-smiths-cur-list]');
    if (list && !list.children.length) {
      LIST.forEach(function (c) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'smiths-cur__opt';
        b.setAttribute('role', 'menuitemradio');
        b.setAttribute('data-smiths-cur-opt', c);
        var name = NAMES[c] ? NAMES[c][IS_AR ? 1 : 0] : c;
        b.innerHTML = '<b>' + c + '</b><span>' + name + '</span>';
        b.addEventListener('click', function () { set(c); close(); });
        list.appendChild(b);
      });
    }
    var btn = pill.querySelector('[data-smiths-cur-toggle]');
    var menu = pill.querySelector('[data-smiths-cur-menu]');
    function open() { if (!menu) return; menu.hidden = false; pill.classList.add('is-open'); btn && btn.setAttribute('aria-expanded', 'true'); }
    function close() { if (!menu) return; menu.hidden = true; pill.classList.remove('is-open'); btn && btn.setAttribute('aria-expanded', 'false'); }
    if (btn && menu) {
      btn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); menu.hidden ? open() : close(); });
      document.addEventListener('click', function (e) { if (!pill.contains(e.target)) close(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    }
    /* Move the pill into the header icon cluster when one is visible; otherwise it stays as a fixed corner pill. */
    try {
      var clusters = document.querySelectorAll('[class*="grid-area:icons"]');
      var host = null;
      for (var i = 0; i < clusters.length; i++) {
        var r = clusters[i].getBoundingClientRect();
        if (r.width > 0 && r.height > 0) { host = clusters[i]; break; }
      }
      if (host) {
        host.insertBefore(pill, host.firstChild);
        pill.classList.add('smiths-cur--header');
      } else {
        pill.classList.add('smiths-cur--float');
      }
    } catch (e) { pill.classList.add('smiths-cur--float'); }
    pill.hidden = false;
    renderPill();
  }

  /* ---------- boot ---------- */
  function boot() {
    loadRates();
    scan(document.body);
    applyAll();
    cartNote();
    mountPill();
    emit();
    try {
      new MutationObserver(function (muts) {
        if (applying) return;
        for (var i = 0; i < muts.length; i++) {
          var m = muts[i];
          if (m.type === 'characterData') { schedule(m.target.parentNode); return; }
          if (m.addedNodes && m.addedNodes.length) { schedule(document.body); return; }
        }
      }).observe(document.body, { childList: true, subtree: true, characterData: true });
    } catch (e) {}
    setTimeout(autoGeo, 400);
  }
  window.SmithsCurrency = {
    get: function () { return { code: active, rate: rate(active), decimals: decimals(active), store: STORE, country: CURRENT_COUNTRY }; },
    set: set,
    format: format,
    convert: convert,
    rate: rate,
    list: LIST.slice(),
    names: NAMES,
    refresh: function (root) { schedule(root); }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

})();
